/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}                 from '@/util/i.command';
import {TrainTable}               from '@/screens/ide/scenariobrowser/train.table';
import {Period}                   from '@/util/period';
import {DecisionPoint}            from '@/models/scenario/decision.point';
import {
  TrainClass,
  TrainDirection
}                                 from '@/models/scenario/train.class';
import {Track}                    from '@/models/scenario/track';
import {TrackIngress}             from '@/helpers/track.ingress';
import 'ag-grid-enterprise';
import {IRowNode} from "ag-grid-community";


/**
 *
 * @class SetTrainFieldCommand
 *
 * @brief reversible field change in the train table (scenario) browser
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2020
 *
 */
export class SetTrainFieldCommand implements ICommand {

  private newValue: any        = null;
  private oldValue: any        = null;
  private   editor: TrainTable = null;
  private      row: IRowNode   = null;
  private    field: string     = '';


    constructor(field: string, oldValue: any,  newValue: any, editor: TrainTable, row: IRowNode) {

      this.field    = field;
      this.oldValue = oldValue;
      this.newValue = newValue;
      this.editor   = editor;
      this.row      = row;
  }

  /** effect the command */
  execute() {

    this.editor.setField(this.row, this.field, this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setField(this.row, this.field, this.oldValue);
  }

  toString(value: any): string {

    if (value instanceof Period) {

      return (value as Period).asString();
    }

    if (value instanceof DecisionPoint) {

      const dp: DecisionPoint = (value as DecisionPoint);

      return dp._name + dp._mileage.toFixed(2) +  ' mi';
    }

    if (value instanceof TrainClass) {

      const tc: TrainClass = (value as TrainClass);

      return tc._name + ((tc._dir === TrainDirection.EAST) ? ' (E)' : ' (W)');
    }

    if (value instanceof TrackIngress) {

      value = value.track;
    }

    if (value instanceof Track) {

      const track: Track = (value as Track);

      return Track.typeToString(track._type) + track._track;
    }

    return value;
  }

  /** return a string summary of this command */
  asString(): string {

    const a  = this.toString(this.oldValue);
    const b  = this.toString(this.newValue);

    const id = this.row.data.id;

    return `[train/table:set] Train #${id} ` + a + ' => ' + b;
  }

}
